import i18n from 'es2015-i18n-tag';
import { Field, Formik, FormikHelpers } from 'formik';
import * as yup from 'yup';
import Input from '../../../../common/ui-components/input/input.component';
import { TeamAdvisor, TeamModel } from '../../models/team-model';
import FetchTeam from '../../resolver/fetch-team.component';
import { updateTeam } from '../../team-service';
import EditTeam from './edit-team.component';
import { useNavigate } from 'react-router';

interface EditBusinessTeamFormValue {
    name: string;
    sport: string;
    league: string;
    advisor?: TeamAdvisor;
}

const formSchema = yup.object<EditBusinessTeamFormValue>({
    name: yup.string().trim().required(),
    sport: yup.string().trim().required(),
    league: yup.string().trim().required(),
    advisor: yup.object().nullable()
});

interface EditBusinessTeamProps {
    team: TeamModel;
}

type EditBusinessTeam = EditBusinessTeamProps;

const EditBusinessTeam = (props: EditBusinessTeam) => {
    const navigate = useNavigate();

    const onSave = (
        formValue: EditBusinessTeamFormValue,
        { setSubmitting }: FormikHelpers<EditBusinessTeamFormValue>
    ) => {
        const { id } = props.team;
        const { name, sport, league, advisor } = formValue;
        updateTeam({
            id,
            name,
            sport,
            league,
            isBusiness: true,
            advisor,
            members: props.team.members,
            accountId: props.team.accountId
        })
            .then(() => navigate(-1))
            .finally(() => setSubmitting(false));
    };

    return (
        <Formik
            validationSchema={formSchema}
            onSubmit={onSave}
            initialValues={{
                name: props.team.name,
                sport: props.team.sport,
                league: props.team.league,
                advisor: props.team.advisor
            }}
        >
            {formikProps => (
                <EditTeam advisorLabel={i18n`Berater`} {...formikProps} {...props}>
                    <Field
                        component={Input}
                        title={i18n`Firma`}
                        name="sport"
                        className="edit-team__form-field"
                        required
                    />
                    <Field
                        component={Input}
                        title={i18n`Standort`}
                        name="league"
                        className="edit-team__form-field"
                        required
                    />
                </EditTeam>
            )}
        </Formik>
    );
};

const Editor = EditBusinessTeam;

export default () => <FetchTeam>{team => <Editor team={team} />}</FetchTeam>;
